export const setShowCourseMenu = (payload) => {
    return {
        type: 'SET_SHOW_COURSE_MENU',
        payload: payload,
    };
};

export const setUpdateCourseMenuLessons = (payload) => {
    return {
        type: 'SET_UPDATE_COURSE_MENU_LESSONS',
        payload: payload,
    };
};
